import Typed from 'typed.js';

export default {
    init(section: HTMLElement) {
        const variableWordsContainer = section.querySelector(
            '.variable-words'
        ) as HTMLElement;

        if (!variableWordsContainer) return;

        const variableWordsString =
            variableWordsContainer.dataset.variableWords;

        if (!variableWordsString) return;

        const variableWordsArray = variableWordsString.split(',');

        if (!variableWordsArray) return;

        new Typed(variableWordsContainer, {
            strings: variableWordsArray,
            typeSpeed: 60,
            loop: true
        });
    }
};
